import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=1be47f77&scoped=true&"
import script from "./WorkPlace.vue?vue&type=script&lang=js&"
export * from "./WorkPlace.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=1be47f77&prod&lang=less&scope=true&"
import style1 from "./WorkPlace.vue?vue&type=style&index=1&id=1be47f77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be47f77",
  null
  
)

export default component.exports